import Component from '@glimmer/component';
import { t } from 'ember-intl';
import SvgLogo from 'madow-tech/components/svg-logo';
import SocialIcons from 'madow-tech/components/social-icons';

export default class SiteFooter extends Component {
  get year() {
    return new Date().getFullYear();
  }

<template>
  <footer class="relative z-10 border-t border-white/10 py-10">
    <div class="mx-auto max-w-7xl px-4 grid md:grid-cols-3 gap-8 text-sm text-center md:text-left">
      <div class="flex flex-col gap-2.5 items-center md:items-start">
        <div class="flex items-center gap-2">
          <SvgLogo class="relative md:-left-2" @imgClass='h-14.5 w-auto' />
        </div>
        <p class="text-zinc-400">{{t "footer.location"}}</p>
      </div>
      <div class="grid grid-cols-2 gap-6 justify-items-center md:justify-items-start">
        <ul class="space-y-2 text-zinc-300">
          <li><a href="#services" class="hover:text-white">{{t "footer.links.services"}}</a></li>
          <li><a href="#success" class="hover:text-white">{{t "footer.links.work"}}</a></li>
          <li><a href="#team" class="hover:text-white">{{t "footer.links.about"}}</a></li>
        </ul>
        <ul class="space-y-2 text-zinc-300">
          <li><a
              href="#technologies"
              class="hover:text-white"
            >{{t "footer.links.technologies"}}</a></li>
          <li><a href="#contact" class="hover:text-white">{{t "footer.links.contact"}}</a></li>
          <li><a href="#top" class="hover:text-white">{{t "footer.links.backToTop"}}</a></li>
        </ul>
      </div>
      <div class="md:justify-self-end flex flex-col items-center md:items-end gap-4">
        <SocialIcons @class="flex gap-4" @iconClass="h-5 w-5" />
        <div class="text-zinc-500 text-center md:text-right">
          <div>{{t "footer.copyright" year=this.year}}</div>
          <div>{{t "footer.tagline"}}</div>
        </div>
      </div>
    </div>
  </footer>
</template>
